export const UPDATE_YOUR_STORAGE_VERSION_SUCCESS = 'UPDATE_YOUR_STORAGE_VERSION_SUCCESS';
export const ADD_TRUSTED_DEVICE_API_SUCCESS = 'ADD_TRUSTED_DEVICE_API_SUCCESS';
export const STORE_POLICY_SUCCESS = 'STORE_POLICY_SUCCESS';
export const STORE_CAMPAIGN_SUCCESS = 'STORE_CAMPAIGN_SUCCESS';
export const SET_LAST_PAID_ORDER_ID_SUCCESS = 'SET_LAST_PAID_ORDER_ID_SUCCESS';
